import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FiltersService } from "../../../services/filters.service";

@Component({
  selector: "app-date-range-picker",
  templateUrl: "./date-range-picker.component.html",
})
export class DateRangePickerComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() inputFormControlName: string;
  @Input() max: Date | null = null;
  @Input() min: Date | null = null;
  constructor(private filtersService: FiltersService) {}

  ngOnInit(): void {
    this.form.get(this.inputFormControlName)?.valueChanges.subscribe(() => {
      const controlValue = this.form.get(this.inputFormControlName)?.value;
      this.filtersService.updateMultipleQueryFilters({
        page: 1,
        [this.inputFormControlName]: controlValue,
      });
    });
  }
}
